module.exports = __webpack_public_path__ + "img/imagen5.719a9ca8.png";